module.exports = __webpack_public_path__ + "img/n1.bf62a624.png";